module.exports = __webpack_public_path__ + "img/img_visits.7d7ae0d1.png";